export default {"src":"/_next/static/media/logo-small.78995fbc.svg","height":50,"width":42,"blurWidth":0,"blurHeight":0};